// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta-container[data-v-56501ae0]{border-radius:10px!important}.cta-container .cta-content[data-v-56501ae0]{margin:0 auto;text-align:center}.cta-container img[data-v-56501ae0]{width:164px;height:152px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
